"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfirmAppointmentRequestStruct = void 0;
const superstruct_1 = require("superstruct");
exports.ConfirmAppointmentRequestStruct = (0, superstruct_1.type)({
    placeId: (0, superstruct_1.string)(),
    appointmentId: (0, superstruct_1.string)(),
});
//# sourceMappingURL=ConfirmAppointmentRequest.js.map